import { FC } from 'react';

import { isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CreateDropForm } from './createDropForm/CreateDropForm';
import { TelegramDropTable } from './telegramDropTable/TelegramDropTable';

import css from './TelegramBotDrop.module.css';

import { telegramBotService } from 'v2/api/telegramBotService';
import { Loader } from 'v2/components/loader/Loader';

export const TelegramBotDrop: FC = () => {
  const { data, isLoading, mutate } = useSWR('getTelegramBotDrops', telegramBotService.getTelegramBotDrops);

  return (
    <div className={css.telegramDrop}>
      <CreateDropForm onSuccess={mutate} />

      {isLoading ? <Loader /> : isNonNullish(data) && <TelegramDropTable drops={data} onRevalidate={mutate} />}
    </div>
  );
};
